
/* injects from baggage-loader */

'use strict';

const moduleLayoutDD = angular.module('services.layoutEditor.blockDragDrop', [
  'services.editorNamespace',
  'services.layoutEditor.insertSpace',
  'services.layoutEditor.blocksBuilder',
  'services.layoutEditor.blockDropOverlays'
]);

moduleLayoutDD.factory('blockDragDrop', [
  '$timeout', '$injector', 'insertSpace', 'ns', 'blocksBuilder', 'blockDropOverlays', 'blockDragScroll', 'TimeMachine', '$state',
  'Section', 'SectionEmail', 'SectionWebForm', 'SectionLesson', '$rootScope', 'Animation',
  ($timeout, $injector, insertSpace, ns, blocksBuilder, blockDropOverlays, blockDragScroll, TimeMachine, $state,
   Section, SectionEmail, SectionWebForm, SectionLesson, $rootScope, Animation) => {
    let Y;

    if ($state.current.name === 'email.page.editor') {
      Section = SectionEmail;
    }
    if ($state.current.name === 'form.page.editor') {
      Section = SectionWebForm;
    }
    if ($state.current.name === 'lesson.page.editor') {
      Section = SectionLesson;
    }

    const layoutDD = {
      builder: blocksBuilder,
      nearestEdge: {},
      fromBlockMenu: false,
      setEvents: function(dd, y) {
        Y = y;

        dd.before('drag:start', this._beforeDragStart, this);
        dd.on('drag:start', this._onDragStart, this);
        dd.on('drag:drag', this._onDragDrag, this);
        dd.on('drag:over', this._onDragOver, this);
        dd.on('drag:end', this._onDragEnd, this);
        dd.after('drag:end', this._afterDragEnd, this);
        dd.after('drag:start', this._afterDragStart, this);
        dd.on('drag:afterMouseDown', this._afterMouseDown, this);
        dd.on('drag:mouseup', blockDropOverlays.destroyOverlays, blockDropOverlays);
      },
      isEmptyObject: function(obj) {
        for (let prop in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            return false;
          }
        }
        return true;
      },
      _afterMouseDown: function(e) {
        this.widgetsPreCapture();
        blockDropOverlays.createOverlays(e);
      },
      widgetsPreCapture: function() {
        const layoutEditor = $injector.get('layoutEditor');
        const sectionJson = angular.copy(layoutEditor.layout.section);
        const sectionHtml = layoutEditor.layout.one(ns.wrapperClass).get('innerHTML');

        this.oldState = {
          html: sectionHtml,
          json: sectionJson
        };
      },
      widgetsCapture: function() {
        const layoutEditor = $injector.get('layoutEditor');
        const sectionJson = angular.copy(layoutEditor.layout.section);
        const sectionHtml = layoutEditor.layout.one(ns.wrapperClass).get('innerHTML');
        const newState = {
          html: sectionHtml,
          json: sectionJson
        };

        TimeMachine.capture('widgetsChange', {
          oldJson: this.oldState.json,
          newJson: newState.json
        }, {
          oldHtml: this.oldState.html,
          newHtml: newState.html
        });
      },
      _beforeDragStart: function() {
        Y.DD.DDM.syncActiveShims();

        const Spacer = $injector.get('Spacer');
        const insertBlockMenu = $injector.get('insertBlockMenu');

        if (insertBlockMenu.isOpen()) {
          insertBlockMenu.hide();
        }

        Spacer.destroy();
      },
      _onDragStart: function(e, fromMenu) {
        if (fromMenu === null || fromMenu === undefined) {
          fromMenu = false;
        }

        this.fromMenu = fromMenu;
        this.dragNode = e.target.get('node');
        this.colDragNode = e.target.get('node').ancestor('> ' + ns.colClass);
        this.clone = e.target.get('dragNode');

        const $dragNode = $('#' + this.dragNode._node._yuid);

        this.widgetFromList = $dragNode.length && $dragNode.scope().block;
        this.nearestSection = false;

        if (!this.widgetFromList) {
          this.colDragNode.addClass('str-col-from');
        }

        this.setVisibility(this.dragNode, 'hidden');

        if (!this.fromMenu) {
          this.clone.setStyles({
            zIndex: 400
          });
        }
      },
      _afterDragStart: function() {
        Y.DD.DDM.syncActiveShims();
      },
      _onDragDrag: function(e) {
        blockDragScroll.scroll(e);
      },
      _onDragOver: function() {
        const nearestEdge = this.getDropInfo(Y);
        const dropTarget = nearestEdge.node;
        const activeDropElement = Y.DD.DDM.activeDrop.get('node');
        const notSection = !activeDropElement.hasClass(ns.sectionClass.substr(1));

        if (notSection) {
          if (this.builder.isBlock(dropTarget)) {
            this.nearestEdge = nearestEdge;
            insertSpace.alignInsertSpaceBlock(this.nearestEdge, this.dragNode);
          }
        } else {
          const layoutEditor = $injector.get('layoutEditor');

          if (layoutEditor.layout.section.id !== activeDropElement.section.id) {
            this.nearestSection = activeDropElement;
            this.nearestSection.addClass('str-section_focus');
          } else if(this.nearestSection) {
            this.nearestSection.removeClass('str-section_focus');
            this.nearestSection = false;
          }
        }
      },
      createRow: function(content) {
        Y.Node.create('<div class="row ' + ns.rowClass.replace('.', '') + '"></div>').setContent(content);
      },
      createColumn: function(size, content) {
         Y.Node.create('<div class="' + ns.colClass.substr(1) + ' str-col-' + size + '"></div>').setContent(content);
      },
      _onDragEnd: function(e) {
        // Перенос блока в соседнюю секцию (nearestSection)
        if (this.nearestSection && !this.isNewBlock(this.dragNode)) {
          const sectionNode = $rootScope.Y.one('.tpl-wrapper > [data-section-id=' + this.nearestSection.section.id + ']');
          const targetNode = sectionNode.one(ns.wrapperClass);
          const targetCol = targetNode.one(ns.rowClass).one(ns.colClass);

          sectionNode.removeClass('str-section_focus');

          this.setVisibility(this.dragNode, 'visible');
          this.dragNode = Y.DD.DDM.activeDrag.get('node');

          if (targetCol) {
            targetCol.prepend(this.dragNode);
          } else {
            const row = this.createRow(this.createColumn(ns.maxColumns, this.dragNode));
            targetNode.prepend(row);
          }

          this.clean();
          this._afterDragEnd();

          const layoutEditor = $injector.get('layoutEditor');
          const previousSectionRows = sectionNode.section.structure.rows.slice(0);

          Section.beforeSave(sectionNode);
          sectionNode.section.structure = Section.generateJSON(targetNode);
          layoutEditor.setJSONtoSection(sectionNode.section, previousSectionRows);

          this.nearestSection = false;
          return false;
        }

        if (!this.fromMenu) {
          this.clone.setStyles({zIndex: ''});
        }

        const insertBlockMenu = $injector.get('insertBlockMenu');
        const insertSpace = $injector.get('insertSpace');
        const ref = this.direction;

        this.setDragInstances(e);
        this.setVisibility(this.dragNode, 'visible');

        if ((ref === 'left' || ref === 'right') && !insertSpace.enableForInsert()) {
          this._afterDragEnd();
          return false;
        }

        if (this.targetNode && this.dragNode) {
          if (this.newBlock) {
            insertBlockMenu.lockWidgets();
            this.dragNode = insertBlockMenu.createAndInitBlock(this.dragNode, this.targetNode);

            // Прокрутка до нового виджета
            let $targetToScrol = $(this.dragNode._node);
            $timeout(() => {
              Animation.scrollTo($targetToScrol);
            }, 300);
          } else {
            this.dragNode = Y.DD.DDM.activeDrag.get('node');
            this.setWidgetFloating(this.dragNode, this.targetNode);
          }

          const rowTarget = this.targetNode.ancestor(ns.rowClass);

          if (!rowTarget) {
            return false;
          }

          if (this.targetNode.float) {
            this.builder.insertBlock(this.direction, this.dragNode, this.targetNode);
          } else if (this.builder.isBlock(this.targetNode)) {
            switch (this.direction) {
              case 'top':
                this.insertTop();
                break;
              case 'bottom':
                this.insertBottom();
                break;
              case 'left':
              case 'right':
                this.insertSide(rowTarget);
            }
          }
          this.clean();
        }

        insertBlockMenu.updateWidgetsOnResize();
        insertSpace.hideFull();
      },
      _afterDragEnd: function() {
        if (!this.widgetFromList && this.colDragNode) {
          this.colDragNode.removeClass('str-col-from');
        }

        blockDropOverlays.destroyOverlays();

        const layoutEditor = $injector.get('layoutEditor');
        const Spacer = $injector.get('Spacer');

        insertSpace.hide();
        Spacer.init(Y);

        this.builder.initResizers(Y);

        layoutEditor.save();

        this.nearestEdge = false;
        this.isSelf = false;
        this.direction = false;
        this.dragNode = false;
        this.targetNode = false;
        this.widgetsCapture();
      },
      /**
       * _onClick
       * @param e
       * @private
       */
      _onClick: function(e) {
        this.widgetsPreCapture();

        let block = e.currentTarget;

        const layoutEditor = $injector.get('layoutEditor');
        const $sectionNode = $('.tpl-wrapper > [data-section-id=' + layoutEditor.layout.section.id + ']');
        const sectionNode = $rootScope.Y.one('.tpl-wrapper > [data-section-id=' + layoutEditor.layout.section.id + ']');
        const targetNode = sectionNode.one(ns.wrapperClass);
        const targetCol = targetNode.one(ns.rowClass).one(ns.colClass);
        const insertBlockMenu = $injector.get('insertBlockMenu');

        if (insertBlockMenu.widgetIsLock(block)) {
          return false;
        }

        insertBlockMenu.lockWidgets();
        block = insertBlockMenu.createAndInitBlock(block, targetNode);

        if (targetCol) {
          targetCol.prepend(block);
        } else {
          const row = this.createRow(this.createColumn(ns.maxColumns, block));
          targetNode.prepend(row);
        }

        this.clean();
        this._afterDragEnd();

        const previousSectionRows = sectionNode.section.structure.rows.slice(0);

        Section.beforeSave(sectionNode);
        sectionNode.section.structure = Section.generateJSON(targetNode);
        layoutEditor.setJSONtoSection(sectionNode.section, previousSectionRows);

        this.closeEditorNav();
        Animation.scrollTo($sectionNode);
      },

      closeEditorNav: function () {
        const $eTools = $('.e__tools');

        if ($eTools.scope().editorNavOpenWidget) {
          $rootScope.editSection();
        } else {
          $eTools.scope().editorNavOpenWidget = false;
          $eTools.scope().editorNavOpen = false;
          if (!$eTools.scope().$$phase) {
            $eTools.scope().$apply();
          }
        }
      },

      setVisibility: function(el, visibility) {
        el.setStyles({
          visibility: visibility
        });
      },
      setDragInstances: function() {
        if (this.nearestEdge && this.builder.isBlock(this.nearestEdge.node) && !this.isEmptyObject(this.nearestEdge)) {
          this.targetNode = this.nearestEdge.node;
          this.direction = this.nearestEdge.direction;
          this.isSelf = this.dragNode === this.targetNode;
          this.newBlock = this.isNewBlock(this.dragNode);
          this.firstBlock = insertSpace.firstBlock(this.targetNode);
          this.lastBlock = insertSpace.lastBlock(this.targetNode);
          this.oneCol = this.targetNode.ancestor(ns.rowClass).all(ns.colClass).size() === 1;
          this.distanceForBlock = this.nearestEdge.distance > ns.dragBlockToRowDistance;
        }
      },
      insertTop: function() {
        if (this.firstBlock && !this.distanceForBlock) {
          this.builder.insertRow(this.direction, this.dragNode, this.targetNode);
        } else {
          this.builder.insertBlock(this.direction, this.dragNode, this.targetNode);
        }
      },
      insertBottom: function() {
        if (this.lastBlock && !this.distanceForBlock || this.oneCol) {
          this.builder.insertRow(this.direction, this.dragNode, this.targetNode);
        } else {
          this.builder.insertBlock(this.direction, this.dragNode, this.targetNode);
        }
      },
      getCountWidgetsInCol: function(col) {
        return col.all(ns.blockClass).size();
      },
      insertSideOverride: function(direction, dragNode, targetNode, widgetFromList) {
        this.direction = direction;
        this.dragNode = dragNode;
        this.targetNode = targetNode;
        this.distanceForBlock = true;
        this.widgetFromList = widgetFromList;

        const rowTarget = this.targetNode.ancestor(ns.rowClass);
        this.insertSide(rowTarget);
      },
      insertSide: function(rowTarget) {
        const widgetsCountInCol = this.getCountWidgetsInCol(this.targetNode.ancestor(ns.colClass));

        if (this.distanceForBlock && widgetsCountInCol > 1 && !this.isSelf) {
          this.builder.insertRowIntoColumn(this.direction, this.dragNode, this.targetNode);
        } else {
          const sumColElementsSize = Y.one(rowTarget).all(ns.colClass).size();

          if (sumColElementsSize < ns.maxColumns && !this.isSelf) {
            this.builder.insertColumn(this.direction, this.dragNode, this.targetNode, this.widgetFromList);
          }
        }
      },
      setWidgetFloating: function(dragNode, targetNode) {
        if (dragNode.widget) {
          dragNode.widget.float = targetNode.float;

          if (targetNode.float) {
            dragNode.widget.float_size = 6;
          } else {
            delete dragNode.widget.float_size;
          }
        }
      },
      removeFloating: function() {
        const size = blocksBuilder.getColSize(this.dragNode);

        this.dragNode.removeClass('str-col-' + size);
        this.dragNode.removeClass(ns.floatingClass + '-left');
        this.dragNode.removeClass(ns.floatingClass + '-right');
        if (this.dragNode.widget) {
          this.dragNode.widget.float = null;
        }
      },
      clean: function() {
        this.builder.removeEmptyColumns();
        this.builder.removeUnnecessaryRows();
        this.builder.removeEmptyColumns();
        this.builder.removeEmptyRows();
        this.builder.removeEmptySections();
        this.builder.setupSizeColumns(false, this.dragNode);
      },
      isNewBlock: function(drag) {
        return drag.hasClass('new-str-block');
      },
      getDropInfo: function(Y) {
        if (Y === null || Y === undefined) {
          Y = false;
        }

        let result = null;
        let activeDropElement = Y.DD.DDM.activeDrop.get('node');

        if (blockDropOverlays.isOverlay(activeDropElement)) {
          activeDropElement = activeDropElement.ancestor(ns.blockClass);
        }

        const isSelf = activeDropElement.getStyle('visibility') === 'hidden';
        const region = activeDropElement.get('region');

        let leftRegion = region.left;
        let topRegion = region.top;
        let k = region.width + parseInt(activeDropElement.getComputedStyle('marginLeft'), 10) + parseInt(activeDropElement.getComputedStyle('marginRight'), 10);
        let l = region.height + parseInt(activeDropElement.getComputedStyle('marginTop'), 10) + parseInt(activeDropElement.getComputedStyle('marginBottom'), 10);
        let mousePos = Y.DD.DDM.activeDrag.mouseXY;

        const q = {
          x: mousePos[0] < leftRegion + k / 2 ? 'left' : 'right',
          y: mousePos[1] < topRegion + l / 2 ? 'top' : 'bottom'
        };

        leftRegion = 'left' === q.x ? mousePos[0] - leftRegion : leftRegion + k - mousePos[0];
        topRegion = 'top' === q.y ? mousePos[1] - topRegion : topRegion + l - mousePos[1];

        l = Math.min(k, l);
        k = 100 * leftRegion / k;

        mousePos = 100 * topRegion / l;
        l = k < mousePos ? q.x : q.y;

        leftRegion = k < mousePos ? leftRegion : topRegion;

        if (!isNaN(leftRegion)) {
          result = {
            node: activeDropElement,
            direction: l,
            distance: leftRegion,
            quad: q,
            region: region,
            isSelf: isSelf
          };
        }

        return result;
      }
    };

    return layoutDD;
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/services/layout_editor/blockDragDrop.js